import React from "react";
import { Link } from "react-router-dom";
import CardHeader from "../CardHeader";
import DataTableSearch from "../DataTableSearch";
import HeaderContent from "../HeaderContent";
import DataTable from "react-data-table-component";
import guLocale from "../../locales/gu";

const AdminUserListing = ({
  columns,
  data,
  filterText,
  handleFilterChange,
  handleShow,
}) => {
  const locale = guLocale.admin.user;
  const localeGlobal = guLocale.global;
  const paginationComponentOptions = {
    rowsPerPageText: localeGlobal.rowsPerPageText, // Gujarati text for "Rows per page"
    rangeSeparatorText: localeGlobal.rangeSeparatorText, // Gujarati text for "of"
    selectAllRowsItem: true,
    selectAllRowsItemText: localeGlobal.selectAllRowsItemText, // Gujarati text for "All"
  };
  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">{locale.users}</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">{locale.homeBreadcrumb}</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    {locale.users}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <CardHeader className="card-header">
                    <HeaderContent>
                      <DataTableSearch
                        filterText={filterText}
                        handleFilterChange={handleFilterChange}
                      />
                    </HeaderContent>
                  </CardHeader>
                  <div className="card-body">
                    <DataTable
                      pagination
                      columns={columns}
                      data={data} // Use filteredData here
                      noDataComponent={localeGlobal.noRecordsToDisplayLabel}
                      paginationComponentOptions={paginationComponentOptions}
                      highlightOnHover
                      striped
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AdminUserListing;
